import {Carousel, Collapse, Dropdown} from 'bootstrap';
import AOS from 'aos';
import Flickity from 'flickity';
import ModuloBox from './plugins/modulobox.js';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import mixitup from 'mixitup';
import Axios from 'axios';
import CookieNotification from "bb-cookie-notification";

// Initialize Animate On Scroll
AOS.init();

// BenedenBoven cookiescript
new CookieNotification();

if(document.getElementById('contact-form')) {
    let contactForm = document.getElementById('contact-form');
    contactForm.addEventListener('submit', function(event) {
        event.preventDefault();

        let formData = new FormData(this);
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        let validationAlert = document.getElementById('contact-form-validation');

        document.querySelectorAll('.invalid-feedback').forEach(element => {
            if(!element.classList.contains('d-none')) {
                element.classList.add('d-none');
            }
        });

        document.querySelectorAll('.is-invalid').forEach(element => {
            element.classList.remove('is-invalid');
        });

        validationAlert.classList.add('hidden');
        validationAlert.classList.remove('alert-danger');
        Axios.post(contactForm.action, formData).then(response => {
            if(response.data.success) {
                validationAlert.innerHTML = response.data.message;
                validationAlert.classList.add('alert-success');
                validationAlert.classList.remove('hidden');

                contactForm.innerHTML = '';
            }
        }).catch(exception => {
            grecaptcha.reset();
            if(exception.response.data.errors) {
                for(let error in exception.response.data.errors) {
                    let el = contactForm.querySelector('[name="' + error + '"]');
                    el.classList.add('is-invalid');
                    if(el.parentNode.querySelector('.d-none') !== null) {
                        el.parentNode.querySelector('.d-none').classList.remove('d-none');
                    }
                }
            }
        });
    });
}

if(document.querySelector('.filter-container')) {
    let mixer = mixitup(document.querySelector('.filter-container'), {
        selectors: {
            target:  '.filter-item',
            control: '.btn-filter'
        },
        animation: {
            duration: 300,
            easing:   'cubic-bezier(0.645, 0.045, 0.355, 1)'
        },
        callbacks: {
            onMixStart(state, futureState) {
                futureState.show.forEach((element, i) => {
                    if((i + 1) % 2 === 0) {
                        element.classList.remove('mt-5');
                    } else {
                        element.classList.add('mt-5');
                    }
                });
            }
        }
    })
}

// init Masonry
if(document.querySelector('.grid')) {
    let grid  = document.querySelector('.grid');
    let msnry = new Masonry(grid, {
        itemSelector:    '.grid-item',
        columnWidth:     '.grid-sizer',
        percentPosition: true,
        gutter:          5
    });

    imagesLoaded(grid).on('progress', function() {
        // layout Masonry after each image loads
        msnry.layout();
    });
}

// Init Flickity
if(document.querySelector('.main-carousel')) {
    let elem  = document.querySelector('.main-carousel');
    let flkty = new Flickity(elem, {
        // options
        cellAlign: 'left',
        contain:   true,
        autoPlay:  false
    });
}

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Carousel (BS)
if(document.getElementById('headerCarousel')) {
    let headerCarousel = document.getElementById('headerCarousel')
    let carousel       = new Carousel(headerCarousel, {
        interval: false,
        slide:    false,
        keyboard: true,
        touch:    true
    });
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();
